import { render, staticRenderFns } from "./InvoiceLineFooterItem.vue?vue&type=template&id=0166d00c"
import script from "./InvoiceLineFooterItem.vue?vue&type=script&lang=js"
export * from "./InvoiceLineFooterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports